import { render, staticRenderFns } from "./Billets.vue?vue&type=template&id=d60cd94a&scoped=true&"
import script from "./Billets.vue?vue&type=script&lang=js&"
export * from "./Billets.vue?vue&type=script&lang=js&"
import style0 from "./Billets.vue?vue&type=style&index=0&id=d60cd94a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60cd94a",
  null
  
)

export default component.exports